import * as React from 'react';
import Loader from "../Loader/Loader"
import DebugLayout from "./DebugLayout"
import DefaultLayout from "./DefaultLayout"
import FocusMatchLayout from "./FocusMatchLayout"
import MobileSolutionHeaderLayout from "./MobileSolutionHeaderLayout"
import MobileSolutionLayout from "./MobileSolutionLayout"
import OverlaylessLayout from "./OverlaylessLayout"
import StandaloneLayout from "./StandaloneLayout"
import VideoQALayout from "./VideoQALayout"
import ATPVideoLayout from "./ATPVideoLayout"
import ATPLayout from './ATPLayout';

interface LayoutProps {
    isApplicationReady: boolean
    layoutName: string
    seasonid: number
    matchid: number
    statisticCenterBaseUrl: string
    lang: string
    serverTime: string
    s5Alias: string
    focusmatchid: number
}

const Layout = ( props: LayoutProps ) => {
    return (
        <div>
        {
          props.isApplicationReady
            ? getLayoutByName( props.layoutName, props )
            : <Loader />
        }
        </div>
  )
}

// a collection of all available layouts
export const layouts = {
    defaultLayout:          DefaultLayout,
    debugLayout:            DebugLayout,
    mobileSolutionHeader:   MobileSolutionHeaderLayout,
    mobileSolutionLayout:   MobileSolutionLayout,
    videoQA:                VideoQALayout,
    OverlayLessLayout:      OverlaylessLayout,
    focusMatchLayout:       FocusMatchLayout,
    standalonelayout:       StandaloneLayout,
    simPlayLayout:          FocusMatchLayout,
    ATPVideoLayout:         ATPVideoLayout,
    ATPLayout:              ATPLayout
}

// use a string to check if the layout is available and return the coresponding layout or as fallback the "defaultLayout"
export const getLayoutByName = ( layoutName: string, props: LayoutProps ) => {
    const layout = Object.keys( layouts ).includes( layoutName )
        ? layouts[layoutName]( props )
        : props.focusmatchid // implicitly set focusMatchLayout when having focusmatchid set
            ? <FocusMatchLayout />
            : <DefaultLayout serverTime={props.serverTime} matchid={props.matchid} />
    return (layout)
}

export default Layout;
